/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Withdrawal_RequestedInputs */

const en_withdrawal_requested = /** @type {(inputs: Withdrawal_RequestedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Withdrawal sent on ${i?.date}`)
};

const pl_withdrawal_requested = /** @type {(inputs: Withdrawal_RequestedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wysłano odstąpienie: ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Withdrawal sent on {date}" |
*
* @param {Withdrawal_RequestedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const withdrawal_requested = /** @type {((inputs: Withdrawal_RequestedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Withdrawal_RequestedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_withdrawal_requested(inputs)
	return en_withdrawal_requested(inputs)
});